import axios from 'axios';

import qs from 'qs';
import Auth from '@youfy/shared/helpers/AuthHelper';
import ResponseHelper from 'helpers/ResponseHelper';

class Api {
  context = null;
  headers = {};

  base_endpoint = '';
  baseURL = process.env.REACT_APP_API_URL;

  setContext(ctx) {
    this.context = ctx;
  }

  addHeaders(name, value) {
    this.headers[name] = value;
  }

  getAxios() {
    const token = Auth.getToken();
    const companyId = Auth.getCompany();

    if (token) {
      this.addHeaders('Authorization', `Bearer ${token}`);
    }

    if (companyId) {
      this.addHeaders('CompanyId', companyId);
    }

    const instance = axios.create({
      baseURL: this.baseURL,
      headers: this.headers,
      paramsSerializer: function (params) {
        return qs.stringify(params);
      },
    });

    instance.interceptors.response.use(null, ResponseHelper.errorInterceptor.bind(this));

    return instance;
  }

  getCancelSource() {
    return axios.CancelToken.source();
  }

  doRequest(method, path, options) {
    return new Promise(async (resolve, reject) => {
      const final_path = path === '/' ? '' : path;
      const endpoint = `${this.base_endpoint}/${final_path}`;

      try {
        const response = await this.getAxios()[method](endpoint, options);
        if (response.status === 200) {
          resolve(response.data, response);
        } else {
          reject(response);
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  fetch(params = {}) {
    return this.doRequest('get', '', { params });
  }

  get(id, params = {}) {
    return this.doRequest('get', `${id}`, { params });
  }

  create(data) {
    return this.doRequest('post', '', data);
  }

  update(id, data) {
    return this.doRequest('put', `${id}`, data);
  }

  delete(id, params) {
    return this.doRequest('delete', `${id}`, { params });
  }

  upload(id, data, customParams) {
    const params = {
      ...customParams,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    return this.doRequest('post', `${id}`, data, params);
  }
}

export default Api;
